<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
      {{ 'bikeshop.shop_setup.card_headers.fixed_rental_config' | translate }}
</span>
    </div>
  </div>

  <div class="content">
    <div class="content-header">
      <div>
        <div class="category-header">{{ 'bikeshop.rentals.pricing.bookable_time_units' | translate }}</div>
        <div class="category-description">{{ 'bikeshop.rentals.pricing.bookable_time_units_description' | translate }}
        </div>
      </div>
      <div class="pull-right">
        <div class="margin-top-16" style="margin-bottom: -36px;">
          <button pButton (click)="addTimeUnit()" class="p-button-raised alternate"
                  label="{{'bikeshop.rentals.pricing.add_time_unit' | translate}}"
                  style="width: 200px;"></button>
        </div>
      </div>
    </div>
    <div *ngIf="loadingAllowableTimeUnits" style="margin-top: 16px;display: flex;justify-content: center;">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div class="time-unit-container margin-top-16">
      <div *ngFor="let timeUnit of allowableTimeUnits" class="time-unit-item">
        <div class="time-unit-title"
             (click)="editTimeUnit(timeUnit)">{{timeUnit.unit}} {{timeUnit.unitType}}{{timeUnit.unit > 1 ? 's' : ''}} {{timeUnit.customLabel && timeUnit.customLabel.length > 0 ? (" (" + timeUnit.customLabel + ")") : ""}}</div>
      </div>
      <div class="no-data"
           *ngIf="!loadingAllowableTimeUnits && allowableTimeUnits.length === 0">{{ 'bikeshop.rentals.pricing.no_bookable_time_units' | translate }}</div>
    </div>
  </div>

  <div class="content margin-top-16">
    <div class="content-header">
      <div>
        <div class="category-header">{{ 'bikeshop.rentals.pricing.pricing_configuration' | translate }}</div>
        <div class="category-description">{{ 'bikeshop.rentals.pricing.pricing_configuration_description' | translate }}
        </div>
      </div>
      <div class="pull-right">
        <div class="margin-top-16" style="margin-bottom: -36px;">
          <button pButton (click)="addPriceGroup()" class="p-button-raised alternate"
                  [disabled]="!loadingAllowableTimeUnits && allowableTimeUnits.length === 0"
                  label="{{'bikeshop.rentals.pricing.add_price_group' | translate}}"
                  style="width: 200px;"></button>
        </div>
      </div>
    </div>
    <div *ngIf="loadingPriceGroupsDetail" style="margin-top: 16px;display: flex;justify-content: center;">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div class="price-group-container margin-top-16">
      <div *ngFor="let priceGroup of priceGroupsDetail" class="price-group-item"
           (click)="updatePriceGroup(priceGroup)">
        <div class="price-group-title">{{priceGroup.name}}</div>
        <!-- <div class="price-group-description">{{priceGroup.description}}</div> -->
        <div class="margin-top-16">
          <div *ngFor="let timeUnit of priceGroup.allocatedTimePrice" class="price-group-time-unit"
               [ngClass]="{'red': !timeUnit.internalProductID && !timeUnit.rate}">
            <div><span class="fa"
                       [ngClass]="{'fa-exclamation-triangle': !timeUnit.internalProductID && !timeUnit.rate, 'fa-check': timeUnit.internalProductID || timeUnit.rate}"></span>
              {{timeUnit.unit}} {{timeUnit.unitType}}{{timeUnit.unit > 1 ? 's' : ''}} {{timeUnit.customLabel && timeUnit.customLabel.length > 0 ? (" (" + timeUnit.customLabel + ")") : ""}}
            </div>
            <div *ngIf="timeUnit.rate || timeUnit.internalProductID">
              <div>{{timeUnit.rate | currency : timeUnit.currencySymbol}}</div>
              <div class="fa fa-barcode" [ngClass]="{'dimmed': !timeUnit.internalProductID}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data"
           *ngIf="!loadingPriceGroupsDetail && priceGroupsDetail.length === 0">{{ 'bikeshop.rentals.pricing.no_price_groups' | translate }}</div>
    </div>
  </div>

  <div class="price-group-legend">
    <div><span class="fa fa-check"></span>{{ 'bikeshop.rentals.pricing.legend_configured_time' | translate }}</div>
    <div class="red"><span class="fa fa-exclamation-triangle"></span>{{
      'bikeshop.rentals.pricing.legend_unconfigured_time' | translate }}</div>
  </div>
</div>

<p-sidebar #NavSideBar [(visible)]="showPriceGroup" position="right" [autoZIndex]="true" [baseZIndex]="0"
           [style]="{width:'700px', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="getRentalPriceGroupsDetail(); NavSideBar.destroyModal()">
  <div *ngIf="showPriceGroup">
    <app-add-edit-price-group (close)="closePriceGroup()"
                              [priceGroup]="selectedPriceGroup"></app-add-edit-price-group>
  </div>
</p-sidebar>

<p-dialog *ngIf="showTimeUnitDialog" [(visible)]="showTimeUnitDialog" [modal]="true" [contentStyle]="{'width':'400px'}">
  <p-header>
    {{ selectedTimeUnit.id ? ('bikeshop.rentals.pricing.edit_time_unit' | translate) :
    ('bikeshop.rentals.pricing.add_time_unit' | translate) }}
  </p-header>
  <div>
    <div class="row margin-top-8">
      <div class="col-md-6 label"
           [ngClass]="{'red bold': selectedTimeUnit.unit === undefined || selectedTimeUnit.unit.length === 0}">
        {{ 'bikeshop.rentals.pricing.unit_value' | translate }}:
      </div>
      <div class="col-md-6 value">
        <input type="number" pInputText [(ngModel)]="selectedTimeUnit.unit"/>
      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-md-6 label">
        {{ 'bikeshop.rentals.pricing.unit_type' | translate }}:
      </div>
      <div class="col-md-6 value">
        <div>
          <p-dropdown [options]="timeUnits" [(ngModel)]="selectedTimeUnit.unitTypeID"></p-dropdown>
        </div>
      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-md-6 label"
           [ngClass]="{'red bold': selectedTimeUnit.unit === undefined || selectedTimeUnit.unit.length === 0}">
        {{ 'bikeshop.rentals.pricing.custom_label' | translate }}:
      </div>
      <div class="col-md-6 value">
        <input pInputText [(ngModel)]="selectedTimeUnit.customLabel"
               placeholder="{{ 'bikeshop.rentals.pricing.custom_label_place_holder' | translate }}"/>
      </div>
    </div>

  </div>
  <p-footer>
    <div class="margin-top-16 button-container">
      <div style="display: flex; justify-content: space-between;">
        <div style="display: flex;">
          <div *ngIf="selectedTimeUnit.id" style="margin-right: 20px;">
            <button pButton *ngIf="!removingTimeUnit"
                    label="{{ 'bikeshop.rentals.pricing.remove_time_unit' | translate}}"
                    class="p-button-raised alternate"
                    (click)="removeTimeUnit()" [disabled]="savingTimeUnit"></button>
            <div *ngIf="removingTimeUnit">
              <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
              </p-progressSpinner>
            </div>
          </div>
        </div>
        <button *ngIf="!savingTimeUnit" pButton (click)="saveTimeUnit()" class="p-button-raised"
                label="{{'bikeshop.general.save' | translate}}"
                [disabled]="!isValid() || removingTimeUnit"></button>
        <div *ngIf="savingTimeUnit">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                             animationDuration=".5s"></p-progressSpinner>
        </div>
      </div>
    </div>
  </p-footer>
</p-dialog>
